module.exports = __webpack_public_path__ + "img/kc7.217ec668.png";